import { gql } from 'apollo-angular';

export const SaveEmailToGetResponseDocument = gql`
  mutation saveEmailToGetResponse($email: String!, $funnelId: Int!) {
    saveEmailToGetResponse(email: $email, funnelId: $funnelId)
  }
`;
